export const data = {
  "name": "Even Better Glow™ Light Reflecting Makeup Broad Spectrum SPF 15",
  "imgURL":require('./images/foundation_image.png'),
  "description": "Moderate-coverage foundation instantly perfects, improves evenness of skin.",
  "features": {
    "benefits": "Glow and natural radiance, SPF",
    "finish": "Radiant",
    "keyIngredients": "Corlander Seed, Black Pepper, Patchouli.",
    "coverage": "Sheer to Moderate"
  },
  "ratingURL":require('./images/rating-4.png'),
  "price": "$29.00",
  "shade": {
    "name":"WN 04",
    "color":"#F6DFC8"
  },
  "breadcrumbNav1": "Makeup",
  "breadcrumbNav2": "Foundations",
  "crossSell": {
    "heading": "Works Well With",
    "cta1": "Shop Now",
    "product1": {      
      "imgURL":require('./images/turnaround_overnight_image.png'),
      "name": "Turnaround™ Overnight Revitalizing Moisturizer",
      "price": "$42.00"
    },
    "product2": {
      "imgURL":require('./images/superdefense_daily_image.png'),
      "name": "Superdefense™ Daily Defense Moisturizer Broad Spectrum SPF 20",
      "price": "$48.00"
    },
    "product3": {
      "imgURL":require('./images/even_better_image.png'),
      "name": "Even Better™ Skin Tone Correcting Moisturizer Broad Spectrum SPF 20",
      "price": "$50.00"
    },
    "product4": {
      "imgURL":require('./images/moisture_surge_image.png'),
      "name": "Moisture Surge™ Hydrating Supercharged Concentrate",
      "price": "$39.00"
    }
  } 
}
